'use client'

import Link from 'next/link'
import Image from 'next/image'
import { ChevronLeft } from 'lucide-react'

export function FinanceHeader() {
    return (
        <header className="sticky top-0 z-50 w-full bg-black/90 backdrop-blur-md border-b border-[#D4AF37]/20 py-4 px-4 sm:px-6 lg:px-8">
            <div className="max-w-7xl mx-auto flex items-center justify-between relative">
                {/* Left: Back to News */}
                <Link
                    href="/"
                    className="flex items-center gap-1 text-[#D4AF37] hover:text-[#D4AF37]/80 transition-colors text-sm font-medium"
                >
                    <ChevronLeft className="h-4 w-4" />
                    <span className="hidden sm:inline">Back to News</span>
                </Link>

                {/* Center: Finance Brand */}
                <Link href="/finance" className="absolute left-1/2 -translate-x-1/2 flex items-center gap-2 group hover:opacity-80 transition-opacity">
                    <Image
                        src="/logo.svg"
                        alt="The Trail"
                        width={140}
                        height={32}
                        className="h-6 w-auto sm:h-8"
                        style={{ height: 'auto', width: 'auto' }}
                        priority
                    />
                    <span className="hidden sm:inline-block font-black text-lg tracking-tight text-[#D4AF37]">FINANCE</span>
                </Link>

                {/* Right: Placeholder for User/Actions */}
                <div className="w-24 sm:w-32 flex justify-end">
                    {/* Placeholder for potential future finance-specific actions */}
                </div>
            </div>
        </header>
    )
}
